














import { Vue } from "vue-property-decorator";
import AccountCard from "./AccountCard.vue";

export default Vue.extend({
  name: "AccountSelector",
  props: {
    dictationAccounts: {
      type: Array
    }
  },
  components: {
    "app-account-card": AccountCard
  }
});
